import type { ReactNode } from 'react';
import styles from './StateMessage.module.css';

export function StateMessage({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className={styles.box}>
      <div className={styles.title}>{title}</div>
      {children}
    </div>
  );
}

export function LoadingState({ label = 'Laden…' }: { label?: string }) {
  return <StateMessage title={label} />;
}

export function ErrorState({ message }: { message: string }) {
  return <StateMessage title="Er ging iets mis">{message}</StateMessage>;
}
